import { ContactType, UPSPickUpType } from '../../shared/enum/general-enum';

export class Contact {
  _handle? = 0;
  AdditionalAddressInformation? = '';
  AESCompanyName? = '';
  AESFirstName? = '';
  AESLastName? = '';
  ApartmentSuite = '';
  City = '';
  CompanyName = '';
  ContactId = 'NOID';
  ContactType = ContactType.AddressBook;
  Country = '';
  CustomerId = '';
  Email = '';
  FaxNo = '';
  FirstName = '';
  IsExpress = false;
  IsResidential = false;
  IsUpdated? = false;
  IsUserDefault = false;
  LastName = '';
  NickName = '';
  ProvinceRegion = '';
  State = '';
  StreetAddress = '';
  TelephoneNo = '';
  TelNum = '';
  TotalContacts? = 0;
  UPSLatestPickUpHour? = '';
  UPSLatestPickUpMinute? = '';
  UPSNotifyPickUpHour? = '';
  UPSNotifyPickUpMinute? = '';
  UPSPickUpType = UPSPickUpType.Occasional;
  UserId = 0;
  Zip = '';
  Vat = '';
  TaxID = '';
  EORI = '';
}
